import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import type { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'
import { documentTypeLabel } from 'features/knowledgeDocumentViewer/utils/documentTypeLabels'

export type FilterFieldConfig = {
  id: string
  label: MessageDescriptor
  type: 'text' | 'multiselect'
  accessor: (doc: DocumentTableRow) => string | null
  formatOption?: (
    value: string,
    translate: (descriptor: MessageDescriptor) => string
  ) => string
}

export const FILTER_FIELDS: FilterFieldConfig[] = [
  {
    id: 'title',
    label: msg`File Name`,
    type: 'text',
    accessor: (d) => d.title,
  },
  {
    id: 'documentTitle',
    label: msg`Document Title`,
    type: 'text',
    accessor: (d) => d.documentTitle,
  },
  { id: 'system', label: msg`System`, type: 'text', accessor: (d) => d.system },
  {
    id: 'vendor',
    label: msg`Vendor`,
    type: 'multiselect',
    accessor: (d) => d.vendor,
  },
  {
    id: 'docType',
    label: msg`Type`,
    type: 'multiselect',
    accessor: (d) => d.docType,
    formatOption: documentTypeLabel,
  },
  {
    id: 'drawing',
    label: msg`Drawing Number`,
    type: 'text',
    accessor: (d) => d.drawing,
  },
]

export type CardFilterValues = Record<string, string | string[]>
